import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabhireserviceinpune() {



  const cardData =
  {
    keyword: 'Cab Hire Services in Pune',
    heading: 'Aaryan Travels: Cab Hire Services in Pune',
    headingDescription: 'Aaryan Travels provides dependable Cab Hire Services in Pune for local travel, airport transfers, corporate rides, and outstation trips. Whether you need a cab for daily office commute, a family outing, a one-way journey to Mumbai, or a pilgrimage ride to Shirdi, our fleet of hatchbacks, sedans, SUVs, and tempo travellers ensures safe and comfortable transportation. With professional chauffeurs, transparent pricing, and 24/7 availability, we make cab hire in Pune convenient and hassle-free. From Hinjewadi to Kharadi, Hadapsar to Wakad, Aaryan Travels offers doorstep pickup and reliable cab services across every corner of Pune.',

    top: 'Top Places to Visit in Pune with Aaryan Travels',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic fort and a symbol of Maratha pride. Once the seat of Bajirao I’s rule, it features massive stone walls, grand gateways like the Delhi Darwaza, and sprawling courtyards. Though much of it was destroyed by fire, its ruins still reflect royal grandeur. The evening light and sound show narrates historic tales. Shaniwar Wada stands as Pune’s magnificent heritage landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, built in 1892, holds great significance in India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it serves as a museum displaying their belongings and photographs. The palace’s Italian arches and lush gardens add charm. It is also the resting place of Kasturba Gandhi. Aga Khan Palace is Pune’s tribute to sacrifice and history."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine dedicated to Lord Ganesha. The idol, adorned with gold and jewels, attracts thousands of devotees daily. The temple becomes the center of grand celebrations during Ganesh Chaturthi. Its spiritual aura brings peace and positivity. Dagdusheth Ganpati is Pune’s heart of devotion."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, perched atop a hill, is known for the 1670 battle where Tanaji Malusare fought bravely for Chhatrapati Shivaji Maharaj. Trekkers enjoy scenic routes leading to the top, rewarded with panoramic views of the Sahyadri ranges. Local villagers serve traditional pithla-bhakri near the summit. The fort exudes history and adventure. Sinhagad is Pune’s perfect blend of valor and nature."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva. Carved from a single basalt stone, it features monolithic pillars and a circular Nandi pavilion. Despite being located on a busy road, it maintains a serene atmosphere. Its ancient carvings depict early Indian craftsmanship. Pataleshwar is Pune’s hidden spiritual retreat."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum showcases over 20,000 artifacts collected by Dr. Dinkar Kelkar, reflecting India’s rich cultural past. Exhibits include sculptures, musical instruments, ornaments, and everyday antiques. The recreated Mastani Mahal is a major attraction. It fascinates history lovers and students alike. The museum is Pune’s fascinating archive of heritage."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill offers panoramic views of Pune after a climb of 103 steps. At the top stands the Parvati Temple dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Smaller shrines and a museum add cultural depth. Sunrise and sunset visits offer breathtaking scenery. Parvati Hill is Pune’s sacred and scenic high point."
  },
  {
    "title": "Osho Ashram",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a global center for peace and wellness. Spread across beautifully landscaped gardens, it offers meditation sessions, therapy programs, and spiritual workshops. Visitors from around the world come for rejuvenation and reflection. The tranquil environment promotes inner calm. Osho Ashram is Pune’s international hub of mindfulness."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, arched bridges, and manicured lawns. Families enjoy peaceful walks and photography amidst seasonal flowers. Its serene layout blends nature with artistry. The garden is Pune’s picturesque green retreat."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular spot for weekend drives and evening relaxation. The tranquil reservoir surrounded by hills becomes especially beautiful during monsoon. Local vendors serve roasted corn and tea along the roadside. It is also the starting point for Sinhagad treks. Khadakwasla is Pune’s refreshing escape into nature."
  }
],



"services": [
  {
    "name": "Cab Hire Services in Pune",
    "description": "Cab Hire Services in Pune provide reliable and convenient transportation options tailored for both individual and corporate clients. Whether it's daily commuting, business travel, or special occasions, these services focus on comfort, punctuality, and safety, offering a wide range of vehicles and professional drivers to meet diverse needs."
  },
  {
    "name": "Pune Taxi Booking",
    "description": "Pune Taxi Booking enables easy and quick taxi reservations across the city with options for instant booking and flexible scheduling. Designed to cater to locals and tourists alike, this service ensures timely pickups, transparent pricing, and a smooth ride experience within Pune and its surroundings."
  },
  {
    "name": "Affordable Cab Rental Pune",
    "description": "Affordable Cab Rental Pune combines budget-friendly pricing with quality service, making it an excellent choice for daily commuters, students, and small businesses. Despite competitive rates, the service does not compromise on vehicle standards, safety, or driver professionalism."
  },
  {
    "name": "Chauffeur Driven Cabs Pune",
    "description": "Chauffeur Driven Cabs Pune offers premium transportation with trained and courteous drivers who prioritize passenger comfort and safety. Ideal for executives, VIPs, and important guests, these cabs provide a seamless travel experience with emphasis on discretion and professionalism."
  },
  {
    "name": "Office Cab Hire Pune",
    "description": "Office Cab Hire Pune specializes in providing efficient and scheduled transportation solutions for corporate employees. With fixed routes and timely pickups, the service reduces commute stress and enhances productivity by ensuring employees reach office on time every day."
  },
  {
    "name": "Wedding Cab Services Pune",
    "description": "Wedding Cab Services Pune cater to the unique transportation needs of weddings, offering elegant vehicles and well-trained chauffeurs to ensure guests and bridal parties travel in style. The service includes tailored packages that coordinate multiple pickups and drop-offs with precision."
  },
  {
    "name": "Corporate Taxi Pune",
    "description": "Corporate Taxi Pune delivers professional and reliable taxi services designed for business travel. Whether for client visits, meetings, or airport transfers, this service focuses on comfort, confidentiality, and timely service to meet the demands of the corporate sector."
  },
  {
    "name": "Executive Cab Rental Pune",
    "description": "Executive Cab Rental Pune offers high-end vehicles with premium interiors and advanced features, perfect for senior management and business travelers. The service is known for punctuality, professionalism, and discretion, ensuring a smooth and dignified ride every time."
  },
  {
    "name": "City Cab Pune",
    "description": "City Cab Pune provides convenient and affordable local travel options within the city. From daily commutes to quick errands, these cabs are available throughout Pune, offering reliable rides with experienced drivers familiar with local routes and traffic."
  },
  {
    "name": "Outstation Cab Pune",
    "description": "Outstation Cab Pune specializes in long-distance travel with comfortable vehicles and professional chauffeurs. Perfect for weekend getaways, business trips, and family visits, the service offers flexible packages, including round trips and one-way travel, ensuring a hassle-free experience."
  },
  {
    "name": "Pune Local Cab Hire",
    "description": "Pune Local Cab Hire caters to customers seeking flexible and quick local travel solutions within Pune. This service emphasizes availability, easy booking, and affordable fares, making it a preferred choice for everyday city travel."
  },
  {
    "name": "Premium Cab Services Pune",
    "description": "Premium Cab Services Pune offer luxury vehicles with top-notch amenities and highly professional drivers. These cabs are ideal for special occasions, corporate travel, and clients who demand superior comfort and style."
  },
  {
    "name": "Online Cab Booking Pune",
    "description": "Online Cab Booking Pune provides a user-friendly digital platform for booking cabs instantly or in advance. Featuring real-time tracking, secure payments, and customer support, this service enhances convenience and transparency in cab reservations."
  },
  {
    "name": "Trusted Taxi Services Pune",
    "description": "Trusted Taxi Services Pune emphasize safety, reliability, and excellent customer service. The fleet comprises well-maintained vehicles, and drivers undergo thorough background checks, ensuring peace of mind for passengers."
  },
  {
    "name": "Best Cab Hire Pune",
    "description": "Best Cab Hire Pune is recognized for its superior service quality, punctuality, and a wide range of vehicle options. The service caters to diverse travel needs, ensuring a comfortable and enjoyable ride experience throughout the city."
  }
],
"tableData": [
  ["Cab Hire Services in Pune", "Pune Taxi Booking"],
  ["Affordable Cab Rental Pune", "Chauffeur Driven Cabs Pune"],
  ["Office Cab Hire Pune", "Wedding Cab Services Pune"],
  ["Corporate Taxi Pune", "Executive Cab Rental Pune"],
  ["City Cab Pune", "Outstation Cab Pune"],
  ["Pune Local Cab Hire", "Premium Cab Services Pune"],
  ["Online Cab Booking Pune", "Trusted Taxi Services Pune"],
  ["Best Cab Hire Pune", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Cab Hire Services in Pune",
    "WhyChoosedescription": "Aaryan Travels offers reliable cab hire services in Pune, catering to daily commutes, airport transfers, and outstation trips."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles",
    "WhyChoosedescription": "Choose from a diverse fleet of well-maintained cars to suit your travel needs and budget."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our courteous drivers ensure safe, punctual, and comfortable rides throughout Pune."
  },
  {
    "WhyChooseheading": "Sanitized and Comfortable Cabs",
    "WhyChoosedescription": "All vehicles are regularly cleaned and sanitized for a hygienic and pleasant journey."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy upfront pricing inclusive of fuel, tolls, and driver allowances with no surprise fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings and travel inquiries."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Select hourly, daily, or long-term cab hire options tailored to your schedule and preferences."
  },
  {
    "WhyChooseheading": "Reliable and Timely Service in Pune",
    "WhyChoosedescription": "We ensure prompt pickups and drop-offs for a seamless travel experience."
  }
]



















  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer cab hire services in Pune?',
    answer: 'Yes, Aaryan Travels provides reliable and affordable cab hire services in Pune for all your travel needs.',
  },
  {
    question: 'How can I book cab hire services in Pune with Aaryan Travels?',
    answer: 'You can book easily through our website, mobile app, or by contacting our 24x7 customer support team in Pune.',
  },
  {
    question: 'What types of vehicles are available for cab hire in Pune?',
    answer: 'Aaryan Travels offers a variety of vehicles including sedans, SUVs, and luxury cars for cab hire in Pune.',
  },
  {
    question: 'Are the drivers experienced and licensed for cab hire services in Pune?',
    answer: 'Absolutely. Our drivers are professional, licensed, and trained to ensure your safety and comfort.',
  },
  {
    question: 'Can I customize pickup and drop-off locations for cab hire in Pune?',
    answer: 'Yes, you can specify your preferred pickup and drop-off points anywhere within Pune and nearby areas.',
  },
  {
    question: 'Is the cab hire service available 24x7 in Pune?',
    answer: 'Yes, Aaryan Travels offers round-the-clock cab hire services to accommodate your schedule in Pune.',
  },
  {
    question: 'Are safety and hygiene protocols followed for cab hire services?',
    answer: 'All vehicles are sanitized regularly, and drivers follow strict safety and hygiene guidelines.',
  },
  {
    question: 'What payment options are accepted for cab hire services in Pune?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, bank transfers, and corporate accounts.',
  },
  {
    question: 'Is customer support available during the cab hire period in Pune?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your cab hire experience.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Amit Joshi',
    feedback: 'Aaryan Travels made cab hiring in Pune easy and hassle-free with friendly drivers and reliable service.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Sneha Patil',
    feedback: 'Highly recommend Aaryan Travels for cab hire services in Pune. Comfortable rides and prompt service.',
    rating: 5,
  },
];



























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];






const cabHireServicesPuneSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Cab Hire Services in Pune",
  "description": "Aaryan Travels offers affordable cab hire services in Pune including chauffeur-driven cabs, office and wedding cab hire, corporate taxi services, outstation travel, and premium cab bookings.",
  "provider": {
    "@type": "Organization",
    "name": "Aaryan Travels",
    "url": "https://aaryantravels.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "serviceType": "Cab Hire Service",
  "keywords": "Cab Hire Services in Pune, Pune Taxi Booking, Affordable Cab Rental Pune, Chauffeur Driven Cabs Pune, Office Cab Hire Pune, Wedding Cab Services Pune, Corporate Taxi Pune, Executive Cab Rental Pune, City Cab Pune, Outstation Cab Pune, Pune Local Cab Hire, Premium Cab Services Pune, Online Cab Booking Pune, Trusted Taxi Services Pune, Best Cab Hire Pune"
};









  return (
    <div>
<Helmet>
  <title>Cab Hire Services in Pune | Affordable Taxi Rental & Chauffeur Driven Cabs | Aaryan Travels</title>
  <meta
    name="description"
    content="Book cab hire services in Pune with Aaryan Travels. Affordable chauffeur-driven cabs, office, wedding, corporate, and outstation taxi services with online booking."
  />
  <meta
    name="keywords"
    content="Cab Hire Services in Pune, Pune Taxi Booking, Affordable Cab Rental Pune, Chauffeur Driven Cabs Pune, Office Cab Hire Pune, Wedding Cab Services Pune, Corporate Taxi Pune, Executive Cab Rental Pune, City Cab Pune, Outstation Cab Pune, Pune Local Cab Hire, Premium Cab Services Pune, Online Cab Booking Pune, Trusted Taxi Services Pune, Best Cab Hire Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(cabHireServicesPuneSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/95.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabhireserviceinpune;